export const TRANSPORTERS = "transporters";
export const PARTIES = "parties";
export const PICK_LISTS = "pick-lists";
export const EMPLOYEES = "employees";
export const CHECKER_PANEL = "checker-panel";
export const PENDING_INVOICES = "pending-invoices";
export const STATES = "states";
export const CITIES = "cities";
export const DISPATCHES = "dispatches";
export const COMPANIES = "companies";
export const PRE_DISPATCHES = "pre-dispatches";
export const DISPATCH_SUMMARIES = "dispatch-summaries";
export const INVOICES = "invoices";

export const DASHBOARD_TOTAL_ORDER_PLACED_TODAY = "dashboard/total-order-placed-today";
export const DASHBOARD_TOTAL_ORDER_COMPLETED_TODAY = "dashboard/total-order-completed-today";
export const DASHBOARD_TOTAL_PENDING_PICKLIST = "dashboard/total-pending-picklist";
export const DASHBOARD_TOTAL_PICKLIST_IN_CHECKER_PANEL =
  "dashboard/total-picklist-in-checker-panel";
export const DASHBOARD_WHATSAPP_LOGIN_STATUS = "dashboard/check-whatsapp-login";
export const DASHBOARD_BACKEND_VERSION = "dashboard/version";

export const DASHBOARD_TOTAL_DISPATCH_PENDING = "dashboard/total-dispatch-pending";
export const DASHBOARD_DISPATCH_DATA = "dashboard/dispatch-data";
export const DASHBOARD_PICKER_PACKER_STATS = "dashboard/picker-packer-stats";
